// eslint-disable-next-line import/prefer-default-export
export const ICON_SPRITE_PATH = '/dist/icons/icons.svg';
